module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("To my mother,")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Without you, my words would have never found the page. Thank you for your incredible inner beauty and strength. My deepest regret is that I did not see all of you until you were gone.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "alt": "images",
      "src": "images/fig1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-244f4bb3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 63
// module chunks = 0